import peakABooHeader from "../actions/peekabooHeader";

const hamburgerMenu = ($) => {
	$("#js-hamburger-menu").on("click", () => {
		$("#js-main-menu").toggleClass("is-open");
		$("body").toggleClass("menu-open");
	});

	$("#js-menu-close").on("click", () => {
		$("#js-main-menu").toggleClass("is-open");
		$("body").toggleClass("menu-open");
	});

	peakABooHeader($);
};

export default hamburgerMenu;
